import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useSalesStore } from '@/store/modules/sales'
import { useUserStore } from '@/store/modules/user'
import { registerRoutes } from './register'
import { useCommonStore } from '@/store/modules/use-common.store'
/**
 * 路由配置
 * 包含销售人员登录、用户登录、主页面等路由
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/sales-login',
  },
  {
    path: '/recommend',
    name: 'Recommend',
    component: () => import('@/views/recommend/index.vue'),
    meta: {
      title: '推荐',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/my',
    name: 'My',
    component: () => import('@/views/my/index.vue'),
    meta: {
      title: '我的',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/my/edit-profile',
    name: 'EditProfile',
    component: () => import('@/views/my/edit-profile.vue'),
    meta: {
      title: '修改注册资料',
      keepAlive: false,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/user',
    name: 'UserDetail',
    component: () => import('@/views/user/detail.vue'),
    meta: {
      title: '用户详情',
      keepAlive: false,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/sales-login',
    name: 'SalesLogin',
    component: () => import('@/views/auth/sales-login.vue'),
    meta: {
      title: '销售人员登录',
      keepAlive: false,
      requiresSalesAuth: false,
      requiresUserAuth: false,
    },
  },
  {
    path: '/user-login',
    name: 'UserLogin',
    component: () => import('@/views/auth/user-login.vue'),
    meta: {
      title: '用户登录',
      keepAlive: false,
      requiresSalesAuth: true,
      requiresUserAuth: false,
    },
  },
  {
    path: '/wx-login',
    name: 'WxLogin',
    component: () => import('@/views/auth/wx-login.vue'),
    meta: {
      title: '微信登录',
      keepAlive: false,
      requiresSalesAuth: true,
      requiresUserAuth: false,
    },
  },
  // 搜索相关路由
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue'),
    meta: {
      title: '精准搜索',
      keepAlive: false,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },
  {
    path: '/my/collect',
    name: 'MyCollect',
    component: () => import('@/views/my/collect.vue'),
    meta: {
      title: '我的收藏',
      keepAlive: true,
      requiresSalesAuth: true,
      requiresUserAuth: true,
    },
  },

  // 注册相关路由
  ...registerRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error/404.vue'),
    meta: {
      title: '页面未找到',
      keepAlive: false,
      requiresSalesAuth: false,
      requiresUserAuth: false,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_APP_BASE_PATH),
  routes,
  scrollBehavior(to, from, savedPosition) {
    console.log('scrollBehavior', savedPosition)
    // 如果有保存的滚动位置（如浏览器前进后退），使用保存的位置
    if (savedPosition) {
      return savedPosition
    }

    // // 如果是keep-alive的路由，不改变滚动位置
    // if (to.meta.keepAlive && from.meta.keepAlive) {
    //   return false
    // }

    // 否则滚动到顶部
    return { top: 0 }
  },
})

/**
 * 全局路由守卫
 * 实现token校验和登录状态检查
 */
router.beforeEach(
  (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    // 设置页面标题
    document.title = (to.meta.title as string) || '门店销售系统'

    const salesStore = useSalesStore()
    const userStore = useUserStore()
    const commonStore = useCommonStore()
    // 判断搜索到列表页 清除搜索页缓存
    if (to.name == 'Recommend' && from.name == 'Search') {
      commonStore.removeInclude('Recommend')
      console.log('removeInclude11111', commonStore.routerInclude)
    } else if (to.meta.keepAlive) {
      // 缓存路由
      console.log('to.name', to.name)
      commonStore.addRouterInclude(to.name)
    }
    console.log('routerInclude22222', commonStore.routerInclude)

    // 初始化store状态
    salesStore.initSalesInfo()
    userStore.initUserInfo()

    // 检查是否需要销售人员认证
    if (to.meta.requiresSalesAuth) {
      if (!salesStore.isLoggedIn) {
        // 销售人员未登录，跳转到销售登录页
        next({ name: 'SalesLogin' })
        return
      }
    }

    // // 检查是否需要用户认证
    if (to.meta.requiresUserAuth) {
      if (!userStore.isLoggedIn) {
        // 用户未登录，跳转到用户登录页
        next({ name: 'UserLogin' })
        return
      }
    }

    // 如果已经登录了，访问登录页面则重定向
    if (to.name === 'SalesLogin' && salesStore.isLoggedIn) {
      if (userStore.isLoggedIn) {
        next({ name: 'WxLogin' })
      } else {
        next({ name: 'UserLogin' })
      }
      return
    }

    if (to.name === 'UserLogin' && userStore.isLoggedIn) {
      next({ name: 'WxLogin' })
      return
    }

    next()
  }
)

export default router
